module.exports = __webpack_public_path__ + "img/spain-diabetes-mellitus-female.396994f1.png";